module.exports = __webpack_public_path__ + "static/media/next.4f5d0b6d.svg";